import React from "react";

interface Props {
  /** The raw JSON string held in each Try panel's `responseBody` state. */
  responseBody: string | null;
}

/**
 * Status line under a Try panel's response card. On success the panels store only
 * the envelope's `data`, so a parsed body without a `statusCode` is a 200. On
 * failure the whole envelope is stored, so the real status (401, 403, 429, 500 …)
 * is shown, with the DPI error code appended when the response carries one (429
 * and the Get Token 404 return errorCode null; a 401 has no body at all).
 */
function ResponseStatusFooter({ responseBody }: Props) {
  if (!responseBody) {
    return <p className="text-muted mb-0">No request sent yet.</p>;
  }

  let response: { statusCode?: number; errorCode?: string | null } | null;

  try {
    response = JSON.parse(responseBody);
  } catch {
    return <p className="text-danger mb-0">Response could not be parsed.</p>;
  }

  if (response === null || typeof response !== "object" || response.statusCode === undefined || response.statusCode === 200) {
    return <p className="text-primary mb-0">200 - successful</p>;
  }

  return (
    <p className="text-danger mb-0">
      {response.statusCode === 0
        ? "Network error - request did not reach the API"
        : `${response.statusCode} - unsuccessful`}
      {response.errorCode ? ` (${response.errorCode})` : ""}
    </p>
  );
}

export default ResponseStatusFooter;
